import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";

/**
 * Reusable password-confirmation modal.
 * onConfirm receives the typed password (does NOT validate locally - the backend does).
 */
export default function ConfirmPasswordDialog({
  open,
  onOpenChange,
  title = "Confirme sua identidade",
  description = "Digite sua senha de acesso ao sistema para continuar.",
  confirmLabel = "Confirmar",
  loading = false,
  onConfirm,
  errorMessage = "",
}) {
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (open) setPassword("");
  }, [open]);

  const submit = (e) => {
    e.preventDefault();
    if (!password) return;
    onConfirm(password);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="confirm-password-dialog">
        <DialogHeader>
          <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-2"
               style={{ background: "#FFE4CC", color: "#FF8A00" }}>
            <ShieldAlert className="w-5 h-5" />
          </div>
          <DialogTitle className="font-display">{title}</DialogTitle>
          <DialogDescription className="text-sm text-gray-600">{description}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="confirm-pwd">Senha do usuário</Label>
            <Input
              id="confirm-pwd"
              type="password"
              autoFocus
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Sua senha de login"
              data-testid="confirm-password-input"
              required
            />
            {errorMessage && (
              <div className="text-sm text-red-700 mt-2" data-testid="confirm-password-error">{errorMessage}</div>
            )}
          </div>
          <DialogFooter className="gap-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} data-testid="confirm-password-cancel">
              Cancelar
            </Button>
            <Button type="submit" disabled={loading || !password} className="vp-btn-primary text-white" data-testid="confirm-password-submit">
              {loading ? "Verificando..." : confirmLabel}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
